<template>
    <span class="rosterName">
        <slot></slot>
    </span>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';

    @Component
    export default class DeploymentMarkerRosterName extends Vue {
    }
</script>

<style lang="scss" scoped>
    .rosterName {
        display: var(--other-roster-display, inline);
    }
</style>
